export const SET_INVOICE_DATA = "SET_INVOICE_DATA";
export const RESET_INVOICE_LIST = "RESET_INVOICE_LIST";

const initialState = {
  listLoading: true,
  invoices: [],
  page: 1,
  perpage: 20,
  totalInvoices: 0,
  mainListingInvoices: [],
  mainListingInvoiceCount: 0,
  mainListingPageNo: 1,
  mainListLoading: true,
  mainListingPerPage: 20,
  mainListingSearch: "",
  statusOptions: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_INVOICE_DATA: {
      return { ...state, ...action.payload };
    }
    case RESET_INVOICE_LIST: {
      return { ...state, ...action.payload, page: 1 };
    }
    default:
      return state;
  }
};
